export default {
  place: {
    routes: ['picking-queue']
  },
  rejectedTask: {
    routes: ['picking-queue']
  }
}
